import Layout from '../views/layout/index.vue'
import i18n from '@/lang'
import { generateConfigRoute } from '@com/utils/generateConfigRoute'
import PtLayout from '@pt/views/layout/index.vue'

export default {
  path: '/creative-assets',
  component: Layout,
  redirect: 'noredirect',
  name: 'creative-assets',
  icon: 'asset_library',
  meta: {
    title: i18n.t('playTurbo.leftMenu.aside.menu.myassets.name'),
  },
  children: [
    generateConfigRoute(
      {
        title: i18n
          .t('playTurbo.leftMenu.aside.menu.myassets.asset')
          .toString(),
        pageId: 'user_assets',
      },
      {
        routeConfig: {
          component: PtLayout,
        },
        metaConfig: {
          keys: ['assets'],
        },
      },
    ),
    {
      path: 'template',
      name: 'creative-assets.template',
      redirect: '/creative-assets/template/playable',
      component: () =>
        import('../views/pt-entry/creative-assets/template/index.vue'),
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.myassets.template'),
        defaultPath: '/creative-assets/template',
      },
      children: [
        {
          path: 'playable',
          name: 'creative-assets.template.playable',
          component: () =>
            import('../views/pt-entry/creative-assets/template/playable.vue'),
          meta: {
            title: i18n.t('playTurbo.leftMenu.aside.menu.myproject.playable'),
            defaultPath: '/creative-assets/template',
            keys: ['ps'],
          },
        },
        {
          path: 'video',
          name: 'creative-assets.template.video',
          component: () =>
            import('../views/pt-entry/creative-assets/template/video.vue'),
          meta: {
            title: i18n.t('playTurbo.templateLibrary.template.publicVideo'),
            defaultPath: '/creative-assets/template',
          },
        },
      ],
    },
    {
      path: 'voice-lab',
      name: 'creative-assets.voice-lab',
      component: () =>
        import('../views/pt-entry/creative-assets/voice-lab/index.vue'),
      meta: {
        title: i18n.t('playTurbo.voiceLab.templateHeader.title'),
        defaultPath: '/creative-assets/voice-lab',
      },
    },
    generateConfigRoute(
      {
        title: i18n
          .t('playTurbo.leftMenu.aside.menu.settings.promote')
          .toString(),
        pageId: 'app_manage',
      },
      {
        routeConfig: {
          component: PtLayout,
        },
        metaConfig: {
          keys: ['gm', 'assets', 've', 'vrec', 'ps'],
        },
      },
    ),
  ],
}
